// Material Dashboard 2 React examples
import React from "react";
import ApiDescription from "./ApiDescription";
import requestHeaderTableData from "./tableData";
import ScrollSpy from "react-ui-scrollspy";
import PropTypes from "prop-types";

function FixDocs({ scrollRef, search }) {
  return (
    <div>
      <ScrollSpy
        activeClass="ss-actives"
        offsetBottom={100}
        scrollThrottle={80}
        parentScrollContainerRef={scrollRef}
      >
        <ApiDescription data={requestHeaderTableData} search={search} />
      </ScrollSpy>
    </div>
  );
}
FixDocs.propTypes = {
  scrollRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
  search: PropTypes.string.isRequired,
};
export default FixDocs;
